/* eslint-disable simple-import-sort/imports */
import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL_PLAUSIBLE
const apiKey = import.meta.env.VITE_API_KEY_PLAUSIBLE
const site_id = import.meta.env.VITE_SITE_ID_PLAUSIBLE
// Stats API
export const getAggregate = async (username: string) => {
  try {
    const response = await axios.get(
      `${API_URL}/stats/aggregate`,
      {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
        params: {
          site_id: site_id,
          metrics: 'visits,visitors,pageviews,bounce_rate,visit_duration',
          filters: JSON.stringify({
            page: `/${username}`
          })
        }
      },
    )

    return response.data.results
  } catch (error) {
    console.error('Error creating site:', error)
    throw error
  }
}

export const getClicks = async (username: string) => {
  try {
    const response = await axios.get(
      `${API_URL}/stats/aggregate`,
      {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
        params: {
          site_id: site_id,
          metrics: 'events',
          filters: JSON.stringify({
            goal: 'linkclicked',
            page: `/${username}`
          })
        }
      },
    )

    return response.data.results
  } catch (error) {
    console.error('Error creating site:', error)
    throw error
  }
}

export const getTopLinks = async (username: string) => {
  try {
    const response = await axios.get(
      `${API_URL}/stats/breakdown`,
      {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
        params: {
          site_id: site_id,
          metrics: 'events',
          period: '30d',
          property: 'event:props:link',
          filters: JSON.stringify({
            goal: 'linkclicked',
            page: `/${username}`
          })
        }
      },
    )

    return response.data.results
  } catch (error) {
    console.error('Error creating site:', error)
    throw error
  }
}

export const getPages = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/stats/breakdown?site_id=${site_id}&period=30d&property=event:page&metrics=visitors,bounce_rate`,
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${apiKey}`,
        },
      },
    )

    return response.data.results
  } catch (error) {
    console.error('Error creating site:', error)
    throw error
  }
}

export const getCountries = async (username: string) => {
    try {
      const response = await axios.get(
        `${API_URL}/stats/breakdown`,
        {
          headers: {
            Authorization: `Bearer ${apiKey}`,
          },
          params: {
            site_id: site_id,
            metrics: 'visitors',
            period: '30d',
            limit: 5,
            property: 'visit:country',
            filters: JSON.stringify({
              page: `/${username}`
            })
          }
        },
      )

    return response.data.results
  } catch (error) {
    console.error('Error creating site:', error)
    throw error
  }
}

export const getSources = async (username: string) => {
  try {
    const response = await axios.get(
      `${API_URL}/stats/breakdown`,
      {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
        params: {
          site_id: site_id,
          metrics: 'visitors',
          period: '30d',
          limit: 5,
          property: 'visit:source',
          filters: JSON.stringify({
            page: `/${username}`
          })
        }
      },
    )

  return response.data.results
} catch (error) {
  console.error('Error creating site:', error)
  throw error
}
}

export const getOS = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/stats/breakdown?site_id=${site_id}&period=30d&property=visit:os&metrics=visitors,bounce_rate`,
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${apiKey}`,
        },
      },
    )

    return response.data.results
  } catch (error) {
    console.error('Error creating site:', error)
    throw error
  }
}

export const getDevices = async (username: string, property: string) => {
  try {
    const response = await axios.get(
      `${API_URL}/stats/breakdown`,
      {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
        params: {
          site_id: site_id,
          metrics: 'visitors',
          period: '30d',
          limit: 5,
          property: property,
          filters: JSON.stringify({
            page: `/${username}`
          })
        }
      },
    )

    return response.data.results
  } catch (error) {
    console.error('Error creating site:', error)
    throw error
  }
}

export const getTimeSeries = async (username: string, selectedDates: Date[]) => {
  if(!selectedDates) return;
  try {
    const response = await axios.get(
      `${API_URL}/stats/timeseries`,
      {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
        params: {
          site_id: site_id,
          period: 'custom',
          date: `${selectedDates[0].toISOString().slice(0, 10)},${selectedDates[1].toISOString().slice(0, 10)}`,
          metrics: 'visitors,visits,pageviews',
          filters: JSON.stringify({
            page: `/${username}`
          })
        }
      },
    )

    return response.data.results
  } catch (error) {
    console.error('Error creating site:', error)
    throw error
  }
}

// Site provisioning API
export const createSite = async () => {
  try {
    const response = await axios.post(
      `${API_URL}/sites`,
      {
        domain: 'test-domain.com',
        timezone: 'Europe/London',
      },
      {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      },
    )

    return response.data
  } catch (error) {
    console.error('Error creating site:', error)
    throw error
  }
}